import { JobTitles } from "./jobtitles.component";
import { JobTitle } from "./jobtitle.component";
import { EditJobTitle } from "./jobtitle.edit.component";
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from "@uirouter/angular";
import { jobTitlesState, jobTitleState, newJobTitleState, editJobTitleState } from "./jobtitles.states";
import { AllMaterialModule } from "../../all-material.components";
import { FlexLayoutModule } from "@angular/flex-layout";

import SharedModule from "../../shared/shared.module";
import { CoreModule } from "../../core/core.module";

let JOB_TITLE_STATES = [jobTitlesState, jobTitleState, newJobTitleState, editJobTitleState];

import { ConfirmDialog } from "../../shared/confirm-dialog.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        AllMaterialModule,
        SharedModule,
        CoreModule,
        FlexLayoutModule,
        UIRouterModule.forChild({ states: JOB_TITLE_STATES })
    ],
    declarations: [JobTitles, JobTitle, EditJobTitle],
    entryComponents: [ConfirmDialog]
})
export default class JobTitlesModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/jobtitles/jobtitles.module.ts